<span>
    <mat-form-field [ngClass]="{'is-vertical': isVertical,
                                'has-generate-btn': hasGenerateBtn,
                                'is-confirm-password': isConfirmPassword,
                                'is-current-password': isCurrentPassword,
                                'mat-form-field-invalid': (countOfErrors > 0) && passwordCtrl?.touched,
                                'one-error': countOfErrors === 1 && passwordCtrl?.touched,
                                'two-errors': countOfErrors === 2 && passwordCtrl?.touched,
                                'three-errors': countOfErrors === 3 && passwordCtrl?.touched,
                                'four-errors': countOfErrors === 4 && passwordCtrl?.touched,
                                'five-errors': countOfErrors === 5 && passwordCtrl?.touched}"
    >
        <!--[placeholder]="isVertical ? isConfirmPassword ? 'Confirm Password' : 'Password' : ''"-->
        <input [formControl]=passwordCtrl
               [type]="(hidePassword$ | async) ? 'password' : 'text'"
               [placeholder]="label || (isConfirmPassword ? 'Confirm Password' : 'Password')"
               [required]="required"
               matInput
               [tabindex]="isConfirmPassword ? 4 : 3"
               [id]="isConfirmPassword ? 'confirm-password' : 'new-password'"
               autocomplete="new-password"
               name="new-password"
        >
        <mat-icon matSuffix
                  class="hide-password-icon"
                  (click)="onToggleHideShowPassword()"
        >
            {{(hidePassword$ | async) ? 'visibility_off' : 'visibility'}}
        </mat-icon>
        <button *ngIf="hasGenerateBtn && !isConfirmPassword"
                matSuffix
                mat-raised-button
                color="accent"
                matTooltip="Generate Password"
                aria-label="Auto Generate Password"
                (click)="onGenerateAndCopyPassword()"
                tabindex="5"
                type="button"
        >
            <fa-icon icon="magic"></fa-icon> Generate
        </button>

        <mat-error *ngIf="passwordCtrl?.errors?.required && passwordCtrl?.touched">
            {{ isConfirmPassword ? CONFIRM_PASSWORD_REQUIRED_MESSAGE : PASSWORD_REQUIRED_MESSAGE }}
        </mat-error>

        <mat-error *ngIf="!passwordCtrl?.errors?.required
                          && passwordCtrl?.errors?.minlength"
        >
            {{MIN_LENGTH_ERROR_MESSAGE}}
        </mat-error>

        <mat-error *ngIf="!passwordCtrl?.errors?.minlength
                          && !passwordCtrl?.errors?.required
                          && (passwordErrorMessagesList.length > 0)"
        >
            {{PASSWORD_ERROR_BODY_MESSAGE + passwordErrorMessagesList.join(', ')}}.
        </mat-error>

        <mat-error *ngIf="!passwordCtrl?.errors?.minlength
                          && !passwordCtrl?.errors?.required
                          && passwordCtrl?.errors?.hasConfirmPasswordError"
        >
            {{PASSWORD_MATCH_ERROR_MESSAGE}}
        </mat-error>

        <mat-error *ngIf="!passwordCtrl?.errors?.minlength
                          && !passwordCtrl?.errors?.required
                          && passwordCtrl?.errors?.isNotEqualToEmailError"
        >
            {{hasGenerateBtn ? EQUAL_TO_USERNAME_ERROR_MESSAGE : EQUAL_TO_EMAIL_ERROR_MESSAGE }}
        </mat-error>

         <mat-error *ngIf="!passwordCtrl?.errors?.minlength
                           && !passwordCtrl?.errors?.required
                           && passwordCtrl?.errors?.passwordHasNotAllowableCharacterError"
         >
            {{PASSWORD_CONTAIN_FORBIDDEN_CHARACTERS_MESSAGE}}
        </mat-error>

    </mat-form-field>

    <div *ngIf="!isConfirmPassword && !isCurrentPassword && passwordCtrl.value"
         class="password-strength"
         [ngClass]="{'is-vertical': isVertical}"
    >
        <ng9-password-strength-bar [passwordToCheck]="passwordCtrl.value"
                                   [barLabel]="PASSWORD_STRENGTH_BAR_LABEL"
                                   [barColors]="PASSWORD__STRENGTH_COLORS"
        >
        </ng9-password-strength-bar>
    </div>

    <div class="password-match"
         [ngClass]="{'is-vertical': isVertical}"
         *ngIf="isConfirmPassword
                && !isVertical
                && passwordCtrl.value
                && !passwordCtrl?.errors?.hasConfirmPasswordError
                && !hasPasswordErrors"
    >
        <span>{{PASSWORD_MATCH_MESSAGE}}</span>
        <mat-icon>done</mat-icon>
    </div>
</span>
